<script>
import baseMixin from '@/mixins/baseMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'FormattedLocation',
  mixins: [baseMixin],
  props: {
    location: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      locations: 'locations/bookingLocations',
    }),
    hasMoreThanOneLocation() {
      return this.locations && this.locations.length > 1
    },
  },
}
</script>

<template>
  <article>
    <v-list class="pa-0 mb-0">
      <v-list-item class="pa-0 ma-0">
        <v-list-item-content class="mt-0 pt-0">
          <v-list-item-subtitle class="subtitle-1 mb-2">
            {{ $t('bookingCreate.formLocationTitle') }}
          </v-list-item-subtitle>

          <v-list-item-title>
            <span class="font-weight-medium">{{ location.locationName }}</span>
            <v-btn
              v-if="hasMoreThanOneLocation"
              id="create-booking__change-location-btn"
              small
              text
              color="primary"
              @click="$emit('changeLocation')"
            >
              {{ $t('bookingCreate.formChangeLocationBtn') }}
            </v-btn>
          </v-list-item-title>
          <p>
            {{ `${location.addressLine1} ${location.addressLine2}` }}
          </p>
          <p class="mb-0">
            {{
              `${location.suburb} ${location.state} ${location.postcode} ${location.country}`
            }}
          </p>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </article>
</template>
